import module from 'recursoshumanos/module.js'
import template from './template.html'

const catalogoEstatus = {
  2: 'Inctivo',
  3: 'Activo',
  8: 'Activo',
}

export class RecursoshumanosCargarmovimientosItemCompoent {
  data
  onChange
  expandido = true
  seleccionado = false
  estatus = ''

  $onChanges (changes) {
    if (changes.data) {
      if (changes.data.currentValue.seleccionado) {
        this.expandido = false
      }
    }
  }

  $onInit () {
    this.estatus = catalogoEstatus[this.data.registro.tipo_movimiento]
    this.expandido = !this.data.seleccionado
  }

  seleccionar (opcion) {
    this.expandido = false
    if (this.data.seleccionado === opcion) return
    this.data.seleccionado = opcion
    this.onChange({$event: {detail: this.data}})
  }
}

module.component('recursoshumanosCargarmovimientosItem', {
  controller: RecursoshumanosCargarmovimientosItemCompoent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/cargarmovimientos/item/component.js